import ReactGA from "react-ga4";

interface AnalyticsEvent {
    /* event_name: The name of the event, Refer to product team for the list of event_names */
    event_name: string;

    /* category: Defines the general action of the event, e.g. 'User Interaction', 'Navigation', 'Form Submission', etc. */
    category: string;

    /* action: Defines the specific action performed by the user, e.g. 'Click', 'Hover', 'Drag', etc. */
    action: string;

    /* label: Provides additional context or metadata about the event, "Homepage Hero Button", "Sign Up Form", "Product: iPhone 15" */
    label?: string;
}

export const initializeGA = (): void => {
    try {
        const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
        const env = process.env.NEXT_PUBLIC_ENVIRONMENT || "production";

        if (!measurementId) {
            console.error(
                "Could not retrieve Google Analytics measurement ID!",
            );
            return;
        }
        ReactGA.initialize(measurementId, {
            testMode: env === "development",
        });

        console.info("Google Analytics initialized successfully");
    } catch (error) {
        console.error("Failed to initialize Google Analytics:", error);
    }
};

export const trackPageView = (url: string): void => {
    try {
        ReactGA.send({ hitType: "pageview", page: url });
    } catch (error) {
        console.error("Following Error Occured In Analytics", error);
    }
};

export const trackEvent = (event: AnalyticsEvent): void => {
    try {
        ReactGA.event(event.event_name, {
            category: event.category,
            action: event.action,
            label: event.label,
        });
    } catch (error) {
        console.error("Following Error Occured In Analytics", error);
    }
};

export const trackNewsDetailPageView = (newsId: string): void => {
    try {
        ReactGA.event("news_detail_page_open", {
            category: "Navigation",
            action: "Page Load",
            label: "News Detail Page",
            news_id: newsId,
        });
    } catch (error) {
        console.error("Following Error Occured In Analytics", error);
    }
};
